import { useEffect } from 'react';
import { Box } from '@mui/material';
import { InvoiceService } from 'api';
import { useAuth } from 'contexts/authContext';
import { useInvoicesContext } from 'contexts/invoicesContext';
import { InvoiceTab } from 'root/pathnames';
import { SortDirection } from 'types/invoices';
import { InvoicesClientTable } from './components/InvoicesClientTable';

export const InvoicesClientModule = () => {
  const { user } = useAuth();

  const { getInvoices, loading, invoicesData } =
    InvoiceService.useGetInvoices();
  const { getSetTabParams, getTabParams } = useInvoicesContext();

  const params = getTabParams(InvoiceTab.OWN);
  const setParams = getSetTabParams(InvoiceTab.OWN);

  useEffect(() => {
    setParams((params) => ({
      ...params,
      sortProperty: 'issueDate',
      sortDirection: SortDirection.DESC,
      own: true,
      np: undefined,
    }));
  }, []);

  useEffect(() => {
    getInvoices(params).catch((e) => console.log(e));
  }, [getInvoices, params]);

  return (
    <Box
      alignItems='center'
      display='flex'
      flexDirection='column'
      paddingTop='20px'
    >
      {invoicesData && user?.clientPanelUser && (
        <InvoicesClientTable
          data={invoicesData}
          invoicesLoading={loading}
          setParams={setParams}
          params={params}
        />
      )}
    </Box>
  );
};
